import React, {
  useImperativeHandle,
  forwardRef,
  useState,
  useEffect,
} from 'react';
import {Text, View, TextInput, StyleSheet} from 'react-native';
import {useModal} from '@components/basic/modal';
import {
  padding,
  background,
  flex,
  position,
  borderRadius,
  font,
  fontColor,
  basicColor,
} from '@/components/style';
import {del} from './profile.variable';
import LazyImage from '@/components/basic/image';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import {updateProfile} from './pofile.service';
import globalStore from '@/services/global.state';
import i18n from '@i18n';

import {
  w24,
  h24,
  w295,
  margintb,
  fontSize18,
  height48,
  delIcon,
  pos,
} from './profile.variable';
// import globalStore from '@/services/global.state';
const ModelDemo = (props: any, ref: any) => {
  const [name, seTName] = useState('');
  const [errorMessage, setEerrorMessage] = useState('');
  useEffect(() => {
    if (!name) {
      setEerrorMessage('');
    }
  }, [name]);
  const handleupdateProfile = async () => {
    if (!name.trim()) {
      setEerrorMessage('Please enter a valid name');
      return;
    }
    if (['user', 'username'].includes(name.trim().toLowerCase())) {
      setEerrorMessage('This name is not allowed');
      return;
    }
    try {
      await updateProfile(name.trim(), '');
      const res = await props.getUserInfo();
      globalStore.userInfo = res;
      hide();
      setEerrorMessage('');
    } catch (error) {
      const response = error as any;
      const msg = response?.data?.msg;
      setEerrorMessage(msg || '');
    }
  };
  const {renderModal, show, hide} = useModal(
    <View style={[w295]}>
      <View style={[flex.flex, flex.alignEnd]}>
        <NativeTouchableOpacity
          onPress={() => {
            setEerrorMessage('');
            hide();
          }}>
          <LazyImage
            occupancy={'transparent'}
            imageUrl={del}
            width={w24}
            height={h24}
          />
        </NativeTouchableOpacity>
      </View>
      <View style={[flex.centerByCol]}>
        <Text style={[fontSize18, styles.modalTitle]}>
          {i18n.t('profile.name')}
        </Text>
      </View>
      <View style={[position.rel]}>
        <TextInput
          style={[
            background.lightGrey,
            margintb,
            padding.l,
            borderRadius.xs,
            styles.input,
            name.trim().length > 1 ? styles.inputActive : null,
          ]}
          placeholder={i18n.t('profile.placeholder')}
          placeholderTextColor={'#9FA5AC'}
          value={name}
          onChangeText={text => {
            name.trim().length >= 4 && setEerrorMessage('');
            if (/^[^\u4e00-\u9fa5]+$/.test(text)) {
              seTName(text);
            } else {
              seTName('');
            }
          }}
          maxLength={16}
        />
        <View style={[position.abs, pos, flex.flex, flex.center]}>
          <NativeTouchableOpacity
            onPress={() => seTName('')}
            style={[flex.flex1, flex.centerByRow, padding.lrl]}>
            <LazyImage
              occupancy={'transparent'}
              imageUrl={delIcon}
              width={14}
              height={14}
            />
          </NativeTouchableOpacity>
        </View>
      </View>
      {errorMessage ? (
        <View style={styles.errorWrap}>
          <Text style={styles.errorText}> {errorMessage}</Text>
        </View>
      ) : null}
      <NativeTouchableOpacity
        onPress={() => {
          if (name.trim().length < 4) {
            setEerrorMessage(
              'Username Should Be Between 4 And 16 Characters Long. Please Retype.',
            );
          } else {
            handleupdateProfile();
          }
        }}>
        <View
          style={[
            height48,
            styles.saveButton,
            flex.flex,
            flex.center,
            flex.centerByCol,
            borderRadius.l,
          ]}>
          <Text style={[fontSize18, font.white, font.fm, font.bold]}>
            {i18n.t('profile.save').toUpperCase()}
          </Text>
        </View>
      </NativeTouchableOpacity>
    </View>,
    {
      backDropClose: true,
      overlayStyle: {borderRadius: 20},
    },
  );
  useImperativeHandle(ref, () => ({
    show,
    handleSetName: (str: string) => seTName(str),
  }));
  return <View>{renderModal}</View>;
};

const styles = StyleSheet.create({
  modalTitle: {
    fontWeight: '700',
    color: fontColor.main,
  },
  input: {
    borderColor: '#D8E0EA',
    borderWidth: 1,
    color: fontColor.second,
    fontSize: 14,
    fontWeight: '400',
  },
  inputActive: {
    fontWeight: '700',
  },
  saveButton: {
    backgroundColor: basicColor.primary,
  },
  errorWrap: {
    marginBottom: 16,
    paddingHorizontal: 10,
  },
  errorText: {
    color: '#ff0000',
  },
});

export default forwardRef(ModelDemo);
